import axios from 'axios';

import Config from 'config';
import { RequestLogsParams, RequestLogsResponse } from 'types/interface/request-logs.interface';

class RequestLogsService {
  async getRequestLogs(params: RequestLogsParams): Promise<RequestLogsResponse> {
    return await axios.get(`${Config.FEEDER_SERVER}/v2/requestLogs`, { params });
  }
}

export default new RequestLogsService();
